import { ComponentPropsWithoutRef, Fragment } from 'react';
import { Icon } from '@publicplan/kern-react-kit';

export interface BreadcrumbItem {
  label: string;
  href?: string;
}

export interface BreadcrumbProps extends ComponentPropsWithoutRef<'nav'> {
  items: BreadcrumbItem[];
}

/**
 * Breadcrumb navigation. The last entry is always the current page and is marked with
 * `aria-current="page"` instead of being a link.
 */
export const Breadcrumb = ({
  items,
  className,
  'aria-label': ariaLabel = 'Brotkrumennavigation',
  ...props
}: BreadcrumbProps) => (
  <nav
    {...props}
    aria-label={ariaLabel}
    className={['vf-breadcrumb', className].filter(Boolean).join(' ')}
  >
    <ol className="vf-breadcrumb__list">
      {items.map((item, index) => {
        const isLast = index === items.length - 1;
        return (
          <Fragment key={`${item.label}-${index}`}>
            <li className="vf-breadcrumb__item">
              {item.href && !isLast ? (
                <a className="kern-link kern-link--small" href={item.href}>
                  {item.label}
                </a>
              ) : (
                <span
                  className="kern-body kern-body--small"
                  aria-current="page"
                >
                  {item.label}
                </span>
              )}
            </li>
            {!isLast && (
              <li aria-hidden="true" className="vf-breadcrumb__separator">
                <Icon name="chevron-right" size="small" />
              </li>
            )}
          </Fragment>
        );
      })}
    </ol>
  </nav>
);
